import { render, staticRenderFns } from "./ClientVehicle.vue?vue&type=template&id=e04a68ce"
import script from "./ClientVehicle.vue?vue&type=script&lang=js"
export * from "./ClientVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports